/**
 * REVIEW-AI.UTILS
 * Suggestions of the AI in the assistant : the account has the module "Project assistant" and the person did not turn the
 * switch "AI suggestions" of the owl off (the choice is kept in the browser)
 */

export const REVIEW_AI_DISABLED_KEY: string = "idt-review-ai-disabled"

//The person chose to turn the AI suggestions off
export function isReviewAiDisabled(): boolean {
  try {
    return localStorage.getItem(REVIEW_AI_DISABLED_KEY) === "1"
  } catch {
    return false
  }
}

//The AI suggestions are shown : module of the account, and not turned off by the person
export function isReviewAiEnabled(hasModule: boolean): boolean {
  return hasModule && !isReviewAiDisabled()
}
